import {
    normalizeCompanyID,
} from '../features/auth/authSlice';
/**
 * 冷启动时决定 Redux 应恢复哪个 companyID。
 *
 * 普通用户：
 * 使用 /users/me 返回的固定 companyID。
 *
 * 管理员：
 * URL companyId 优先；
 * URL 没有 companyId 时使用 0（全部公司）。
 */
export const resolveBootstrapCompanyID = ({
    user,
    search = '',
}) => {
    const isAdmin =
        user?.role === 'ADMIN';

    if (!isAdmin) {
        return normalizeCompanyID(
            user?.companyID ??
            user?.companyId
        );
    }

    const params =
        new URLSearchParams(search);

    const urlCompanyID =
        params.get('companyId');

    if (
        urlCompanyID === null ||
        urlCompanyID.trim() === ''
    ) {
        return 0;
    }

    return normalizeCompanyID(
        urlCompanyID
    );
};